import React from 'react';
import SearchList from './features/searchList';
import SaleList from './features/searchList/sale';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './static/assets/css/bootstrap/bootstrap.min.css';
import './static/assets/css/style.css';
function App() {
    if (sessionStorage.getItem("sale")) {
        return <Router>
            {/* <HeaderComponent />*/}
            <Switch>
                <SaleList />
            </Switch>
            {/*<FooterComponent />*/}
        </Router>
    } else {
        return <Router>
            {/* <HeaderComponent />*/}
            <Switch>
                <SearchList />
            </Switch>
            {/*<FooterComponent />*/}
        </Router>
    }

}
export default App;
